export var INTERNAL_SELECTION_KEY = 'table_internal_selection_key';
export var INTERNAL_EXPAND_KEY = 'table_internal_expand_key';
